import ko from 'knockout';
import templateMarkup from 'raw-loader!./panel-header.template.html';
import _ from 'lodash';
import CommonDialog from '../../../../../components/modal-dialog/common-dialog/common-dialog';
import DataProvider from '../../../../../app/data-framework/data-provider';
import PermissionService from '../../../../../services/permission.service';
import UtilsService from '../../../../../services/utils.service';
import FilterModel from '../../filter/data/filter.model';
import LoginService from "../../../../../services/login.service";

var normalizeTitle = _.flowRight([_.snakeCase, _.deburr]);

function PanelHeader(params) {
    var self = this;

    self.dataProvider = DataProvider.getInstance();
    self.dashboardsAndTabsList = params.dashboardsAndTabsList;
    self.selectedTab = params.selectedTab;
    self.viewId = params.viewId;
    self.permissionService = new PermissionService(LoginService.userObject);
    self.options = params.options.options || {};

    self.showCaptureButton = ko.observable(!!_.get(params, 'showCaptureButton'));
    self.showDeleteButton = ko.observable(!!_.get(params, 'showDeleteButton'));
    self.showOptionsButton = ko.observable(!!_.get(params, 'showOptionsButton'));

    // signals
    self.deleteButtonClicked = _.get(params, 'signals.deleteButtonClicked');
    self.optionsButtonClicked = _.get(params, 'signals.optionsButtonClicked');
    self.clonePanelClicked = _.get(params, 'signals.clonePanelClicked');
    self.movePanelClicked = _.get(params, 'signals.movePanelClicked');
    self.copyPanelClicked = _.get(params, 'signals.copyPanelClicked');
    self.copyPanelAdvancedClicked = _.get(params, 'signals.copyPanelAdvancedClicked');

    self.headerTitle = params.title;
    self.pageId = normalizeTitle(ko.unwrap(params.title));
    self.panelId = ko.unwrap(params.panelId);
    self.panelEl = document.getElementById('panel-'+ko.unwrap(self.panelId));

    // hide submenus when dropdown is hidden
    $(self.panelEl).find('div.dropdown').first().on('hidden.bs.dropdown', function(e) {
      if (self.submenuEl) {
        self.submenuEl.classList.remove('show');
      }
    });

    self.metricOrKpi = false;
    if ((self.options.metricId || self.options.kpiId)) {
        self.metricOrKpi = true;
    }
}

PanelHeader.prototype = {
    confirmAlertCreation: function() {
        let self = this;
        // CommonDialog.confirm('Would you like to navigate away to alert creation screen?').then(function(confirmed) {
        //     if (confirmed) {
                self.navigateToAlert();
            // }
        // });
    },
    isActiveTab: function(dashboardAndTabsListViewId, tabId) {
        return dashboardAndTabsListViewId === this.viewId || (this.selectedTab() && tabId === this.selectedTab().id);
    },
    navigateToAlert: function() {
        let locationString = '#monitoring/moi/new?category=' + this.options.categoryId + '&metric=' + (this.options.metricId || this.options.kpiId);
        if (this.options.groupBy) {
          locationString += '&groupBy=' + (_.isArray(this.options.groupBy)
              ? this.options.groupBy.join(',')
              : this.options.groupBy);
        }
        let filter = new FilterModel(false, undefined, this.options.filters);
        if (!filter.isEmpty()) {
            window.sessionStorage.setItem('monitoringFilter', JSON.stringify(filter.getActiveFilters()));
        } else {
          window.sessionStorage.removeItem('monitoringFilter');
        }
        let href = window.location.href;
        locationString += '&next=' + href.substring(href.indexOf('#') + 1);
        locationString += '&title=' + this.options.title;
        window.location.href = locationString;
    },
    onDeleteClicked: function() {
        var self = this;
        UtilsService.dispatchSignal(self.deleteButtonClicked, self.panelId);
    },
    onShowOptionsClicked: function() {
        var self = this;
        UtilsService.dispatchSignal(self.optionsButtonClicked, self.panelId);
    },
    onTitleKeyPress: function(element, event) {
        if (event.keyCode === 13) {
            event.target.blur();
        }
        return true;
    },

    clonePanel: function() {
      let self = this;
      UtilsService.dispatchSignal(self.clonePanelClicked, self.panelId);
    },

    movePanel: function(tab) {
      let self = this;
      UtilsService.dispatchSignal(self.movePanelClicked, [self.panelId, tab]);
    },

    copyPanel: function() {
      let self = this;
      UtilsService.dispatchSignal(self.copyPanelClicked);
    },

    copyPanelAdvanced: function() {
      let self = this;
      UtilsService.dispatchSignal(self.copyPanelAdvancedClicked);
    },

    toggleSubmenu: function(data, event) {
      let self = this;
      let submenu = getMatchingSibling(event.target, '.dropdown-menu');
      event.stopPropagation();

      if (!self.submenuEl) {
        self.submenuEl = submenu;
      }
      submenu.classList.toggle('show');

      function getMatchingSibling(el, selector) {
        let sibling = el.nextElementSibling;

        if (!selector) { return sibling }

        while (sibling) {
          if (sibling.matches(selector)) {
            return sibling;
          }
          sibling = sibling.nextElementSibling;
        }
      }
    }
};

export default PanelHeader;

ko.components.register('panel-header', { template: templateMarkup, viewModel: PanelHeader });
